/* eslint-disable */

/*
 * This is a generated file created by deere-ui-svg-to-react.
 *
 * Please do not modify this file directly as it will be regenerated at build time.
 */

"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

exports["default"] = _react2["default"].createClass({
    displayName: "checkmark-green",

    getDefaultProps: function getDefaultProps() {
        return {
            "st0": {
                "fill": "#367C2B"
            },
            "checkmarkGreen": {
                "backgroundImage": "none",
                "backgroundPosition": "0% 0%",
                "display": "inline",
                "fill": "#333"
            },
            "width": "17",
            "height": "13.8"
        };
    },

    render: function render() {
        return _react2["default"].createElement(
            "svg",
            { id: "Layer_1", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 17 13.8", className: "checkmark-green", width: this.props.width, height: this.props.height, style: this.props.checkmarkGreen },
            _react2["default"].createElement("path", { className: "st0", d: "M16.5.4c-.6-.5-1.6-.5-2.1.1l-8.2 9.6-3.6-3.6C2 5.9 1 5.9.4 6.5c-.6.6-.6 1.5 0 2.1l4.7 4.7c.6.5 1.5.7 2.2-.1l9.3-10.8c.6-.5.5-1.5-.1-2z", style: this.props.st0 })
        );
    }
});

/* eslint-enable */
module.exports = exports["default"];



// WEBPACK FOOTER //
// ./~/cap-it-ui.toggles/~/cap-it-ui.icons/lib/checkmark-green.js